import {
  NavbarBackLink,
  NavbarButton,
  NavbarContainer,
  NavbarLink,
  NavbarLinksGroup,
} from './components';

// ─────────────────────────────────────────────────────────────────────────────

export const Navbar = {
  Container: NavbarContainer,
  LinksGroup: NavbarLinksGroup,
  Link: NavbarLink,
  BackLink: NavbarBackLink,
  Button: NavbarButton,
};
